import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { Form, Input } from "antd";
import { useStores } from "@/store";
import { Header, Loading } from "@/components";
import "./index.less";
import { handleDeepLink } from "@/service/utils";

const RedemptionVoucher = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { voucherStore, HeaderStore } = useStores();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [form] = Form.useForm();
  const [str, setStr] = useState("");
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");
  const okBtnDisabled = useMemo(() => !str, [str]);
  const handleCancel = () => {
    form.resetFields();
    setStatus("");
    setStr("");
    setMessage("");
    setConfirmLoading(false);
  };

  const handleChange = (e) => {
    setStr(e.target.value);
    setStatus("");
    setMessage("");
  };

  const handleAddVoucher = async () => {
    setConfirmLoading(true);
    const code = form.getFieldValue("voucherCode");
    // return handleDeepLink("https://diningcity.allapp.link/cojng49rogtsrsuqc81g")
    voucherStore
      .addVoucher(code, { return_voucher_info: true })
      .then((res) => {
        if (res?.detail?.deal) {
          handleDeepLink(res?.detail?.brief_owners?.[0]?.deeplink);
        } else {
          setStatus("error");
          setMessage(t("VOUCHERS.not_deal_code"));
        }
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err?.data?.full_messages[0]);
      })
      .finally(() => {
        setConfirmLoading(false);
      });
  };
  return (
    <div className="redemption-voucher">
      <Header
        title={t("walkin.Voucher")}
        className="redemption-voucher-header"
      ></Header>
      <div className="redemption-voucher-content">
        <Form className="redemption-voucher-form" form={form}>
          <div className="redemption-voucher-title">{t("WEB.Enter code")}</div>
          <div className="redemption-voucher-desc">
            {t("WEB.Add voucher des2")}
          </div>
          <Form.Item name="voucherCode" validateStatus={status} help={message}>
            <Input
              placeholder={t("VOUCHERS.ENTER")}
              value={str}
              size="large"
              onChange={handleChange}
            />
          </Form.Item>
        </Form>
      </div>
      <div className="redemption-voucher-footer">
        {/* <div className="redemption-voucher-button" onClick={handleCancel}>
          {t("CANCEL")}
        </div> */}
        <div
          className="redemption-voucher-button"
          type="primary"
          disabled={okBtnDisabled}
          onClick={handleAddVoucher}
        >
          {confirmLoading ? <Loading /> : t("CONFIRM")}
        </div>
      </div>
    </div>
  );
};

export default RedemptionVoucher;
